const routes = [


	//---- "Administration" root ----
	{
		path: '/admin',
		name: "admin-root",
		component: () => import("/admin/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "", pageTitle: "Administration" }
	},


	//---- Reporting ----
	{
		path: '/admin/reporting/access',
		name: "admin-reporting-access",
		component: () => import("/admin/reporting/access.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Reporting access" }
	},


	//---- People ----
	{
		path: '/admin/people',
		name: "admin-people-index",
		component: () => import("/admin/people/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "People" }
	},
	{
		path: '/admin/people/staff',
		name: "admin-people-staff",
		component: () => import("/admin/people/staff.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-index", pageTitle: "Staff" }
	},
	{
		path: '/admin/people/staff/new',
		name: "admin-people-staff-new",
		component: () => import("/admin/people/person.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-staff", pageTitle: "Add staff" }
	},
	{
		path: '/admin/people/staff/:id',
		name: "admin-people-staff-edit",
		component: () => import("/admin/people/person.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-staff", pageTitle: "Staff - {personName}" }
	},
	{
		path: '/admin/people/roles',
		name: "admin-people-roles",
		component: () => import("/admin/people/roles.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-index", pageTitle: "Roles" }
	},
	{
		path: '/admin/people/teams',
		name: "admin-people-teams",
		component: () => import("/admin/people/teams.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-index", pageTitle: "Teams" }
	},
	{
		path: '/admin/people/teams/new',
		name: "admin-people-teams-new",
		component: () => import("/admin/people/add-team.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-teams", pageTitle: "Add team" }
	},
	{
		path: '/admin/people/teams/:id',
		name: "admin-people-teams-detail",
		component: () => import("/admin/people/team-detail.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-teams", pageTitle: "Teams - {teamName}" }
	},
	{
		path: '/admin/people/seats-inclusions',
		name: "admin-people-seats-inclusions",
		component: () => import("/admin/people/seats-inclusions.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-index", pageTitle: "Seats & inclusions" }
	},

	{
		path: '/admin/people/pending-invites',
		name: "admin-people-pending-invites",
		component: () => import("/admin/people/pending-invites.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-people-index", pageTitle: "Pending invites" }
	},


	//---- Clients & Buckets ----
	{
		path: '/admin/clients-and-buckets',
		name: "admin-clients-and-buckets-index",
		component: () => import("/admin/clients-and-buckets/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Clients & Buckets" }
	},
	{
		path: '/admin/clients-and-buckets/clients',
		name: "admin-clients-and-buckets-clients",
		component: () => import("/admin/clients-and-buckets/clients.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-index", pageTitle: "Clients" }
	},
	{
		path: '/admin/clients-and-buckets/clients/new',
		name: "admin-clients-and-buckets-clients-new",
		component: () => import("/admin/clients-and-buckets/add-client.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-clients", pageTitle: "Add client" }
	},
	{
		path: '/admin/clients-and-buckets/clients/:id',
		name: "admin-clients-and-buckets-clients-detail",
		component: () => import("/admin/clients-and-buckets/client-detail.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-clients", pageTitle: "Clients - {clientName}" }
	},
	{
		path: '/admin/clients-and-buckets/buckets',
		name: "admin-clients-and-buckets-buckets",
		component: () => import("/admin/clients-and-buckets/buckets.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-index", pageTitle: "Buckets" }
	},
	{
		path: '/admin/clients-and-buckets/buckets/new',
		name: "admin-clients-and-buckets-buckets-new",
		component: () => import("/admin/clients-and-buckets/add-bucket.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-buckets", pageTitle: "Add bucket" }
	},
	{
		path: '/admin/clients-and-buckets/buckets/:id',
		name: "admin-clients-and-buckets-buckets-detail",
		component: () => import("/admin/clients-and-buckets/bucket-detail.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-buckets", pageTitle: "Buckets - {bucketName}" }
	},
	{
		path: '/admin/clients-and-buckets/task-templates',
		name: "admin-clients-and-buckets-task-templates",
		component: () => import("/admin/clients-and-buckets/task-templates.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-index", pageTitle: "Task templates" }
	},
	{
		path: '/admin/clients-and-buckets/task-templates/new',
		name: "admin-clients-and-buckets-task-templates-new",
		component: () => import("/admin/clients-and-buckets/task-template-detail.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-task-templates", pageTitle: "Add task template" }
	},
	{
		path: '/admin/clients-and-buckets/task-templates/:id',
		name: "admin-clients-and-buckets-task-templates-detail",
		component: () => import("/admin/clients-and-buckets/task-template-detail.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-clients-and-buckets-task-templates", pageTitle: "Task templates - {templateName}" }
	},


	//---- Projects ----
	{
		path: '/admin/projects/presets',
		name: "admin-projects-presets",
		component: () => import("/admin/projects/presets.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Project presets" }
	},


	//---- CRM & Sales ----
	{
		path: '/admin/crm-and-sales',
		name: "admin-crm-and-sales-index",
		component: () => import("/admin/crm-and-sales/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "CRM & Sales" }
	},
	{
		path: '/admin/crm-and-sales/pipeline-stages',
		name: "admin-crm-and-sales-pipeline-stages",
		component: () => import("/admin/crm-and-sales/pipeline-stages.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Pipeline stages" }
	},
	{
		path: '/admin/crm-and-sales/contact-types',
		name: "admin-crm-and-sales-contact-types",
		component: () => import("/admin/crm-and-sales/contact-types.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Contact types" }
	},
	{
		path: '/admin/crm-and-sales/deal-sources',
		name: "admin-crm-and-sales-deal-sources",
		component: () => import("/admin/crm-and-sales/deal-sources.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Deal sources" }
	},
	{
		path: '/admin/crm-and-sales/loss-categories',
		name: "admin-crm-and-sales-loss-categories",
		component: () => import("/admin/crm-and-sales/loss-categories.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Loss categories" }
	},
	{
		path: '/admin/crm-and-sales/product-catalogue',
		name: "admin-crm-and-sales-product-catalogue",
		component: () => import("/admin/crm-and-sales/product-catalogue.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Product catalogue" }
	},
	{
		path: '/admin/crm-and-sales/product-catalogue/new',
		name: "admin-crm-and-sales-product-catalogue-new",
		component: () => import("/admin/crm-and-sales/add-product.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-product-catalogue", pageTitle: "Add product" }
	},
	{
		path: '/admin/crm-and-sales/product-catalogue/:id',
		name: "admin-crm-and-sales-product-catalogue-detail",
		component: () => import("/admin/crm-and-sales/add-product.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-product-catalogue", pageTitle: "Product catalogue - {productName}" }
	},
	{
		path: '/admin/crm-and-sales/pipeline-visibility',
		name: "admin-crm-and-sales-pipeline-visibility",
		component: () => import("/admin/crm-and-sales/pipeline-visibility.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Pipeline visibility" }
	},
	{
		path: '/admin/crm-and-sales/sales-targets',
		name: "admin-crm-and-sales-sales-targets",
		component: () => import("/admin/crm-and-sales/sales-targets.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-crm-and-sales-index", pageTitle: "Sales targets" }
	},


	//---- Mobile ----
	{
		path: '/admin/mobile',
		name: "admin-mobile-index",
		component: () => import("/admin/mobile/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Mobile" }
	},
	{
		path: '/admin/mobile/licensed-users',
		name: "admin-mobile-licensed-users",
		component: () => import("/admin/mobile/licensed-users.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-mobile-index", pageTitle: "Licensed users" }
	},
	{
		path: '/admin/mobile/geofencing-sites',
		name: "admin-mobile-geofencing-sites",
		component: () => import("/admin/mobile/geofencing-sites.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-mobile-index", pageTitle: "Geofencing sites" }
	},


	//---- Financials ----
	{
		path: '/admin/financials',
		name: "admin-financials-index",
		component: () => import("/admin/financials/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Financials" }
	},
	{
		path: '/admin/financials/rates',
		name: "admin-financials-rates",
		component: () => import("/admin/financials/rates.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Rates" }
	},
	{
		path: '/admin/financials/currency-fx',
		name: "admin-financials-currency-fx",
		component: () => import("/admin/financials/currency-fx.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Currency & FX" }
	},
	{
		path: '/admin/financials/billable-targets',
		name: "admin-financials-billable-targets",
		component: () => import("/admin/financials/billable-targets.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Billable targets" }
	},
	{
		path: '/admin/financials/rounding',
		name: "admin-financials-rounding",
		component: () => import("/admin/financials/rounding.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Rounding" }
	},
	{
		path: '/admin/financials/period-locking',
		name: "admin-financials-period-locking",
		component: () => import("/admin/financials/period-locking.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Period locking" }
	},
	{
		path: '/admin/financials/cost-rates',
		name: "admin-financials-cost-rates",
		component: () => import("/admin/financials/cost-rates.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-financials-index", pageTitle: "Cost rates" }
	},


	//---- Organisation Settings ----
	{
		path: '/admin/org-settings',
		name: "admin-org-settings-index",
		component: () => import("/admin/org-settings/index.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-root", pageTitle: "Organisation Settings" }
	},
	{
		path: '/admin/org-settings/org-locations',
		name: "admin-org-settings-org-locations",
		component: () => import("/admin/org-settings/org-locations.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-org-settings-index", pageTitle: "Org & locations" }
	},
	{
		path: '/admin/org-settings/approvals',
		name: "admin-org-settings-approvals",
		component: () => import("/admin/org-settings/approvals.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-org-settings-index", pageTitle: "Approvals" }
	},
	{
		path: '/admin/org-settings/terminology',
		name: "admin-org-settings-terminology",
		component: () => import("/admin/org-settings/terminology.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-org-settings-index", pageTitle: "Terminology" }
	},
	{
		path: '/admin/org-settings/general-security',
		name: "admin-org-settings-general-security",
		component: () => import("/admin/org-settings/general-security.vue"),
		meta: { layout: "primary", section: "admin", module: "admin", parentRouteName: "admin-org-settings-index", pageTitle: "General & security" }
	},


]


export default routes;
